export default __webpack_public_path__ + "static/media/SportsEquipment.c1d93363.svg";